// ISO9001Certification.jsx
import React from "react";

export default function ISO9001Certification() {
  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Content */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            ISO 9001 Certification
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            ISO 9001 Quality Management Certification Support
          </h1>
          <div className="w-20 h-1 bg-yellow-500 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks supports ISO 9001 Certification for quality
            management systems, helping organisations align processes and
            documentation with ISO 9001:2015 requirements for consistent
            product and service quality.[web:335][web:331]
          </p>
          <p className="text-gray-700">
            The focus is on building or refining a practical QMS that reflects
            how the organisation really works while meeting the standard&apos;s
            expectations on leadership, risk, and continual improvement.[web:313][web:332]
          </p>
        </div>

        {/* Right: Image */}
        <div className="relative">
          <div className="absolute -inset-4 border border-yellow-400 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100">
            <img
              src="https://images.pexels.com/photos/5668830/pexels-photo-5668830.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="Team reviewing ISO 9001 quality management documentation"
              className="w-full aspect-square object-cover"
            />
          </div>
        </div>
      </section>

      {/* DOCUMENTS & WHY CHOOSE US */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Documents Required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required for ISO 9001 Certification
            </h2>
            <p className="text-gray-700 mb-4">
              ISO 9001 requires defined quality commitments, controlled
              processes, and clear organisational information, with some
              documents mandatory and others created as needed.[web:313][web:328][web:330]
            </p>
            <div className="bg-gray-50 border border-yellow-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>
                  Quality policy and quality objectives approved by top
                  management, forming the backbone of the quality management
                  system.[web:313][web:332]
                </li>
                <li>
                  Process documentation such as procedures, flowcharts, work
                  instructions, and records that describe and evidence how key
                  activities are planned, operated, and monitored.[web:313][web:331][web:336]
                </li>
                <li>
                  Company details and context information, including
                  organisational structure, roles and responsibilities, scope of
                  the QMS, and description of products/services.[web:332][web:336]
                </li>
                <li>
                  Supporting records like internal audit reports, management
                  review minutes, risk assessments, and corrective action
                  logs.[web:313][web:328][web:331]
                </li>
              </ul>
            </div>
          </div>

          {/* Why Choose Hawkins & Brooks */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              The service is designed to turn ISO 9001 into a practical,
              value-adding framework rather than a paperwork exercise.[web:331][web:332]
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  QMS Expertise
                </h3>
                <p className="text-gray-700 text-sm">
                  Guidance on interpreting ISO 9001 clauses, defining scope, and
                  mapping real-world processes to standard requirements in a
                  structured way.[web:313][web:332]
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Accurate Certification Support
                </h3>
                <p className="text-gray-700 text-sm">
                  Help with preparing documentation and records that auditors
                  expect to see, reducing nonconformities and rework during
                  stage 1 and stage 2 audits.[web:328][web:330][web:333]
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Professional Advisory
                </h3>
                <p className="text-gray-700 text-sm">
                  Ongoing advisory for maintaining the QMS, closing audit
                  findings, and preparing for surveillance and recertification
                  audits.[web:331][web:336]
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href="/contact"
                className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
              >
                Get Consultation
              </a>
              <a
                href="tel:+919217468906"
                className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-yellow-500 text-yellow-600 font-medium hover:bg-yellow-50 transition-colors text-sm"
              >
                Call Hawkins &amp; Brooks
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
